import { Input as ShadInput } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { ChangeEvent, useId } from "react"

export type InputProps = Pick<
  React.ComponentProps<typeof ShadInput>,
  "type" | "className" | "id" | "placeholder" | "name"
> & {
  label?: string
  onChange?: (value: string) => void
  onBlur?: (value: string) => void
}

export default function Input({
  className,
  label,
  id,
  onChange,
  onBlur,
  ...props
}: InputProps) {
  const defaultId = useId()
  const inputId = id || defaultId

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    if (onChange) {
      onChange(e.target.value)
    }
  }

  function handleBlur(e: ChangeEvent<HTMLInputElement>) {
    if (onBlur) {
      onBlur(e.target.value)
    }
  }

  return (
    <div className="w-full">
      {label && (
        <Label
          htmlFor={inputId}
          className="text-label-text mb-1.5 text-sm leading-5 font-medium"
        >
          {label}
        </Label>
      )}

      <ShadInput
        {...props}
        id={inputId}
        className={className}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </div>
  )
}
